import { $translate } from '@/utils/i18n';
export const searchListConfig = {
    searchList: [
        {
            type: 'date',
            value: 'opTime',
            label: $translate('lang.E3202101280005', { defaultText: '扫码时间' })
        },
        {
            type: 'date',
            value: 'prodTime',
            label: $translate('lang.E3202101280006', { defaultText: '生产时间' })
        },
        {
            type: 'input',
            value: 'shipOrgName',
            placeholder: $translate('lang.E3202101280007', { defaultText: '发货仓库名称' }),
            label: $translate('lang.E3202101280007', { defaultText: '发货仓库名称' })
        },
        {
            type: 'input',
            value: 'recOrgName',
            placeholder: $translate('lang.E3202101280008', { defaultText: '收货仓库名称' }),
            label: $translate('lang.E3202101280008', { defaultText: '收货仓库名称' })
        },
        {
            type: 'input',
            value: 'customerCode',
            placeholder: $translate('lang.E3202101280009', { defaultText: '直发客户编码' }),
            label: $translate('lang.E3202101280009', { defaultText: '直发客户编码' })
        },
        {
            type: 'input',
            value: 'customerName',
            placeholder: $translate('lang.E3202101280010', { defaultText: '直发客户名称' }),
            label: $translate('lang.E3202101280010', { defaultText: '直发客户名称' })
        },
        {
            type: 'checkbox',
            value: 'isShowRed',
            label: $translate('lang.E3202101280011', { defaultText: '是否显示红冲' }),
            span: 4
        },
        {
            type: 'checkbox',
            value: 'isReadTheEnd',
            label: $translate('lang.E3202101280012', { defaultText: '是否读取最终节点' }),
            span: 4
        }
    ]
};
